import React from 'react';
import PropTypes from 'prop-types';

import { AIconButton } from './';

export default class ASmartField extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value.name,
			search: undefined,
			filteredItems: undefined,
			error: props.error || false,
			isEditing: false,
		};
		this.bindHandles();
	}

	componentWillReceiveProps(props) {
		this.setState({ value: props.value.name });
	}

	bindHandles() {
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);
		this.handleIconClick = this.handleIconClick.bind(this);
	}

	handleOnChange(event) {
		const error = !this.isFieldValid({ value: event.target.value });
		const value = event.target.value; // eslint-disable-line

		this.setState({ isEditing: value.length > 0, search: value });

		if (this.props.onSelect) {
			this.props.onSelect(undefined);
		}

		if (value.length === 0) {
			this.setState({ filteredItems: undefined });
		} else {
			const re = new RegExp(value, 'gi');
			this.setState({ filteredItems: this.props.items.filter(item => item.name.match(re)) });
		}

		this.bounce(() => {
			this.setState({ error });
			clearTimeout(this.timer);

			if (this.props.onChange) {
				this.props.onChange(value, error);
			}
		});
	}

	handleKeyUp(event, option) {
		if (event.keyCode !== 13) {
			return;
		}

		this.handleSelect(option);
	}

	handleSelect(option) {
		this.setState({ isEditing: false, search: undefined });

		if (this.props.onSelect) {
			this.props.onSelect(option);
		}
	}
	handleIconClick() {
		if (this.props.onDelete) {
			this.props.onDelete(this.state.value);
		} else {
			this.setState({ isEditing: !this.state.isEditing });
		}

	}

	bounce(closure) {
		clearTimeout(this.timer);

		this.timer = setTimeout(() => {
			closure();
		}, 500);
	}


	isFieldValid({ value }) {
		return !(this.props.required && value.length === 0);
	}


	render() {
		let cName = this.state.isEditing ? `active ${this.props.className}` : this.props.className;
		let dropDown;

		if (this.state.error) {
			cName += `${cName} error`;
		}

		if (this.state.isEditing) {
			dropDown = (
				<ul className="drop-down--body">
					{
						(this.state.filteredItems || this.props.items).map(option => (
							<li
								role="button"
								tabIndex="0"
								key={option.uuid}
								className="a-list-row drop-down--row"
								option={option.name}
								onClick={() => this.handleSelect(option)}
								onKeyUp={event => this.handleKeyUp(event, option)}
							>
								{option.name}
							</li>))
					}
				</ul>
			);
		}

		let type = this.state.isEditing ? 'arrowUp' : 'arrowDown';
		type = this.props.onDelete ? 'close' : type;

		return (
			<div className={`a-smart-type ${this.props.className}`}>
				<div className={`a-smart-field ${cName}`}>
					<input
						id={this.props.id}
						value={this.state.search || this.state.value}
						placeholder={this.props.placeholder}
						required={this.props.required}
						onChange={this.handleOnChange}
					/>
					<AIconButton
						type={type}
						className="a-smart-field--icon"
						onClick={this.handleIconClick}
					/>
				</div>
				{dropDown}
			</div>
		);
	}
}

ASmartField.propTypes = {
	id: PropTypes.string.isRequired,
	className: PropTypes.string,
	value: PropTypes.oneOf([PropTypes.object, PropTypes.string]),
	items: PropTypes.array,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	error: PropTypes.bool,
	onChange: PropTypes.func,
	onSelect: PropTypes.func,
	onDelete: PropTypes.func,
};

ASmartField.defaultProps = {
	className: '',
	value: undefined,
	items: [],
	placeholder: '',
	required: false,
	error: false,
	onChange: undefined,
	onDelete: undefined,
	onSelect: undefined,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.smart-field.js